module.exports = __webpack_public_path__ + "static/6-169be30da6f95fd05a9b1f37709bf9b2.svg";